import Cookies from 'js-cookie';
import { v4 as uuidv4 } from 'uuid';

export default {
  setAnonymousUserId(anonymousUserId: string) {
    localStorage.setItem('riseup.anonymousUserId', anonymousUserId);
  },
  getId() {
    let anonymousUid = localStorage.getItem('riseup.anonymousUid');
    if (!anonymousUid) {
      anonymousUid = `anon-${uuidv4()}`;
      localStorage.setItem('riseup.anonymousUid', anonymousUid);
      Cookies.set('ajs_anonymous_id', anonymousUid);
    }
    return anonymousUid;
  },
  reset() {
    const anonymousUid = `anon-${uuidv4()}`;
    localStorage.setItem('riseup.anonymousUid', anonymousUid);
    Cookies.set('ajs_anonymous_id', anonymousUid);

    return anonymousUid;
  },
};
